var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"app"}},[_c('div',{staticClass:"app-wrapper"},[_c('app-header'),_c('router-view'),_c('outdated-browser-info')],1),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }